/* Form Page to edit a Moodboard
 * The word moodshots is used through the app in the urls for moodboards */
import React, { useEffect, useRef, useState } from "react"

import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import Container from "react-bootstrap/Container"
import Asset from "../../components/Asset"

import Upload from "../../assets/upload.png"
import styles from "../../styles/Scene.module.css"
import appStyles from "../../App.module.css"
import btnStyles from "../../styles/Button.module.css"
import Image from "react-bootstrap/Image"
import Alert from "react-bootstrap/Alert"

import { useHistory, useParams } from "react-router-dom"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
// import Asset2 from "../../components/Asset2"
import {
  useCharactersContext,
  useLocationsContext,
  useScenesContext,
} from "../../contexts/Scene_chars_locs"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast"

const MAX_FILE_SIZE_MB = 5;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const MoodboardEdit = () => {
  useRedirect()
  const host = useHostName()
  const [errors, setErrors] = useState({})

  const scenes = useScenesContext()
  const characters = useCharactersContext()
  const locations = useLocationsContext()
  const [postData, setPostData] = useState({
    scene: "",
    number: "",
    title: "",
    content: "",
    character: "",
    location: "",
    image1: "",
    image2: "",
    image3: "",
    image4: "",
    image5: "",
    image1Preview: null,
    image2Preview: null,
    image3Preview: null,
    image4Preview: null,
    image5Preview: null,
    image1Type: null,
    image2Type: null,
    image3Type: null,
    image4Type: null,
    image5Type: null,

  })

  const {
    scene,
    number,
    title,
    content,
    character,
    location,
    image1,
    image2,
    image3,
    image4,
    image5,
  } = postData

  const imageInput1 = useRef(null)
  const imageInput2 = useRef(null)
  const imageInput3 = useRef(null)
  const imageInput4 = useRef(null)
  const imageInput5 = useRef(null)

  const history = useHistory()
  const { id } = useParams()

  useEffect(() => {
    const handleMount = async () => {
      try {
        const fetchContentType = async (url) => {
          const response = await fetch(url, { method: "HEAD" });
          return response.headers.get("Content-Type");
        };

        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const { data } = await axiosReq.get(`/moodshots/${id}/`);
          const {
            scene,
            number,
            title,
            content,
            character,
            location,
            image1,
            image2,
            image3,
            image4,
            image5,
          } = data;

          const [type1, type2, type3, type4, type5] = await Promise.all([
            image1 ? fetchContentType(image1) : null,
            image2 ? fetchContentType(image2) : null,
            image3 ? fetchContentType(image3) : null,
            image4 ? fetchContentType(image4) : null,
            image5 ? fetchContentType(image5) : null,
          ]);

          setPostData({
            scene,
            number,
            title,
            content,
            character,
            location,
            image1,
            image2,
            image3,
            image4,
            image5,
            image1Preview: image1,
            image2Preview: image2,
            image3Preview: image3,
            image4Preview: image4,
            image5Preview: image5,
            image1Type: type1,
            image2Type: type2,
            image3Type: type3,
            image4Type: type4,
            image5Type: type5,
          });
        } else {
          const { data } = await axiosInstance.get(
            `${localStorage.getItem("projectSlug")}/moodshots/${id}/`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
              withCredentials: true,
            }
          );

          const {
            scene,
            number,
            title,
            content,
            character,
            location,
            image1,
            image2,
            image3,
            image4,
            image5,
          } = data;

          const [type1, type2, type3, type4, type5] = await Promise.all([
            image1 ? fetchContentType(image1) : null,
            image2 ? fetchContentType(image2) : null,
            image3 ? fetchContentType(image3) : null,
            image4 ? fetchContentType(image4) : null,
            image5 ? fetchContentType(image5) : null,
          ]);

          setPostData({
            scene,
            number,
            title,
            content,
            character,
            location,
            image1,
            image2,
            image3,
            image4,
            image5,
            image1Preview: image1,
            image2Preview: image2,
            image3Preview: image3,
            image4Preview: image4,
            image5Preview: image5,
            image1Type: type1,
            image2Type: type2,
            image3Type: type3,
            image4Type: type4,
            image5Type: type5,
          });
        }
      } catch (err) {
        console.error("Error in moodshot useEffect:", err);
      }
    };

    handleMount();
  }, [id]);


  const handleChange = (event) => {
    setPostData({
      ...postData,
      [event.target.name]: event.target.value,
    })
  }

  const validateImageSize = (file, inputRef) => {
    if (file.size <= MAX_FILE_SIZE_BYTES) {
      return true;
    }

    if (inputRef.current) {
      inputRef.current.value = "";
    }

    toast.error(`Only ${MAX_FILE_SIZE_MB} MB files are allowed.`, {
      duration: 3000,
    });

    return false;
  };

  const handleChangeImage1 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput1)) {
        return;
      }
      if (postData.image1Preview) {
        URL.revokeObjectURL(postData.image1Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image1: file,
        image1Preview: previewUrl,
        image1Type: file.type,
      }));
    }
  };

  const handleChangeImage2 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput2)) {
        return;
      }
      if (postData.image2Preview) {
        URL.revokeObjectURL(postData.image2Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image2: file,
        image2Preview: previewUrl,
        image2Type: file.type,
      }));
    }
  };

  const handleChangeImage3 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput3)) {
        return;
      }
      if (postData.image3Preview) {
        URL.revokeObjectURL(postData.image3Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image3: file,
        image3Preview: previewUrl,
        image3Type: file.type,
      }));
    }
  };

  const handleChangeImage4 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput4)) {
        return;
      }
      if (postData.image4Preview) {
        URL.revokeObjectURL(postData.image4Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image4: file,
        image4Preview: previewUrl,
        image4Type: file.type,
      }));
    }
  };

  const handleChangeImage5 = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (!validateImageSize(file, imageInput5)) {
        return;
      }
      if (postData.image5Preview) {
        URL.revokeObjectURL(postData.image5Preview);
      }
      const previewUrl = URL.createObjectURL(file);
      setPostData((prev) => ({
        ...prev,
        image5: file,
        image5Preview: previewUrl,
        image5Type: file.type,
      }));
    }
  };


  const handleChangeScene = (event) => {
    const scene = event.target.value.split("_")[0]
    const number = event.target.value.split("_")[1]
    setPostData({
      ...postData,
      scene: scene,
      sceneNumber: number,
    })
  }

  const dropfields = (
    <div>
      <Row>
        <Col xs={4} className="text-center">
          {/* scene */}
          <Form.Group controlId="scenedrop" className="mb-2">
            <Form.Label className={`${styles.Bold} `}>Scene</Form.Label>
            <Form.Control
              as="select"
              name="scene"
              className={styles.InputChar}
              value={scene.id}
              onChange={handleChangeScene}
              aria-label="scene select"
            >
              <option value="">{number} </option>
              {scenes.results.length &&
                scenes.results.map((scene) => (
                  <option key={scene.id} value={`${scene.id}_${scene.number}`}>
                    {scene.number} - {scene.location} "{scene.title}"
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          {errors?.scene?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={4} className="text-center">
          {/* location */}
          <Form.Group controlId="locationdrop" className="mb-2">
            <Form.Label className={`${styles.Bold} `}>Location</Form.Label>
            <Form.Control
              as="select"
              name="location"
              className={styles.InputChar}
              value={location}
              onChange={handleChange}
              aria-label="location select"
            >
              <option>{location} </option>
              {locations.results.length &&
                locations.results.map((location) => (
                  <option key={location.id} value={location.name}>
                    {location.name}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          {errors?.location?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
        <Col xs={4} className="text-center">
          {/* character */}
          <Form.Group controlId="characterdrop" className="mb-2">
            <Form.Label className={`${styles.Bold} `}>Character</Form.Label>
            <Form.Control
              as="select"
              name="character"
              className={styles.InputChar}
              value={character}
              onChange={handleChange}
              aria-label="character select"
            >
              <option>{character} </option>
              {characters.results.length &&
                characters.results.map((character) => (
                  <option key={character.id} value={character.role}>
                    {character.role}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
          {errors?.character?.map((message, idx) => (
            <Alert variant="warning" key={idx}>
              {message}
            </Alert>
          ))}
        </Col>
      </Row>
    </div>
  )

  const handleSubmit = async (event) => {
    event.preventDefault()
    setPostData({
      ...postData,
    })
    const formData = new FormData()

    formData.append("scene", scene)
    formData.append("number", number)
    formData.append("title", title)
    formData.append("content", content)
    formData.append("scene", scene)
    formData.append("character", character)
    formData.append("location", location)
    if (imageInput1.current.files[0]) {
      formData.append("image1", imageInput1.current.files[0])
    }
    if (imageInput2.current.files[0]) {
      formData.append("image2", imageInput2.current.files[0])
    }
    if (imageInput3.current.files[0]) {
      formData.append("image3", imageInput3.current.files[0])
    }
    if (imageInput4.current.files[0]) {
      formData.append("image4", imageInput4.current.files[0])
    }
    if (imageInput5.current.files[0]) {
      formData.append("image5", imageInput5.current.files[0])
    }

    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const data = await axiosReq.put(`/moodshots/${id}/`, formData)
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`Moodboard Updated`);
          history.goBack()
        }
      } else {
        const data = await axiosInstance.put(
          `${localStorage.getItem("projectSlug")}/moodshots/${id}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        if (data?.success === false) {
          toast.error(data?.error?.response?.data.non_field_errors[0], {
            duration: 3000,
            position: "top-right",
          });
        }
        else {
          toast.success(`Moodboard Updated Successfully!`);
          history.goBack()
        }
      }
    } catch (err) {
      console.log(err)
      if (err.response?.status !== 401) {
        setErrors(err.response?.data)
      }
    }
  }

  const textFields = (
      <div>
      <Row className="text-center">
      <Col md={6} className="d-flex justify-content-center">
      <Form.Group controlId="title" className={`${styles.Width3}`} >
      <Form.Label className={`${styles.BoldScene} `} >Title</Form.Label>
      <Form.Control 
      type="text"
      className={styles.Input}
      name="title"
      value={title}
      onChange={handleChange}
          />
  </Form.Group>
  {errors?.title?.map((message, idx) => (
    <Alert variant="warning" key={idx}>
      {message}
    </Alert>
  ))}
      </Col>
      <Col md={6} className="mt-3 mt-md-0 d-flex justify-content-center">
      <Form.Group controlId="content" className={`${styles.Width3}`} >
      <Form.Label className={`${styles.BoldScene} `} >Content</Form.Label>
      <Form.Control 
          className={styles.InputScene}
          type="text"
          name="content"
          as="textarea"
          rows={1}
          value={content}
          onChange={handleChange}
          />
  </Form.Group>
  {errors?.content?.map((message, idx) => (
    <Alert variant="warning" key={idx}>
      {message}
    </Alert>
  ))}
      </Col>
      </Row>
      </div>
  ) 

  const buttons = (
  <div className="text-center mb-3">    
    <Button
      className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 mr-3`}
      onClick={() => history.goBack()}
    >
      Cancel
    </Button>
    <Button className={`${btnStyles.Button} ${btnStyles.Blue} px-3 px-md-5 ml-3`} type="submit">
      Update
    </Button>
  </div>
);

  return (
    <div>
      <TopBox title="Edit Moodboard" />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      {/* titles  */}
      <Row>
      <Col className="text-center" >
      {!number && !location && !character ? (
      <h5 className={`mt-1 mb-2 py-1 ${styles.SubTitleMood }`}
      style={{ textTransform: 'uppercase'}}>
      <span className={`${styles.Span100 }`} 
      style={{ fontStyle: 'italic' }}>{title} - </span>Moodboard</h5>
      ) : (
        <h5 className={`mt-1 mb-2 py-1 ${styles.SubTitleMood }`}
      style={{ textTransform: 'uppercase'}}>
        {number && <span className={`${styles.Span100 }`}>
          Scene {number} - </span> }
      {location && <span className={`${styles.Span100 }`}> 
        {location} - </span> }
      {character && <span className={`${styles.Span100 }`}> 
        {character} - </span> }
      Moodboard
      </h5>
        )}
      </Col>
      </Row>
      <Form onSubmit={handleSubmit} className={`pt-3 px-3 ${styles.White }`}>
      {textFields}
      <hr/>
      <div>
      {/* image 1 2 */}
      <Row className="d-flex align-items-center">
      <Col xs={12} md={6} className={`pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 1</p>
      <Form.Group className="text-center pt-3">
      {postData.image1Preview ? (
      postData.image1Type === "application/pdf" ? (
      <>
          <iframe
          src={postData.image1Preview}
          width="40%"
          height="100px"
          style={{ borderRadius: 8, border: "none" }}
          title="PDF Preview"
          />
          <Form.Label
          className={`${btnStyles.Button} ${btnStyles.Blue}`}
          htmlFor="image-upload1"
          >
          Change the file
          </Form.Label>
      </>
      ) : (
      <>
          <figure>
          <Image
              className={appStyles.iframe}
              width="70%"
              height="120px"
              src={postData.image1Preview}
              rounded
          />
          </figure>
          <Form.Label
          className={`${btnStyles.Button} ${btnStyles.Blue}`}
          htmlFor="image-upload1"
          >
          Change the image
          </Form.Label>
      </>
      )
      ) : (
      <Form.Label
      htmlFor="image-upload1"
      >
      <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
      </Form.Label>
      )}
      <Form.Control
      type="file"
      id="image-upload1"
      accept="image/*,.pdf"
      onChange={handleChangeImage1}
      ref={imageInput1}
      />
      </Form.Group>
      {errors?.image1?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
      {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 2</p>
      <Form.Group>
      {postData.image2Preview ? (
          postData.image2Type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image2Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload2"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image2Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload2"
              >
              Change the image
              </Form.Label>

          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload2"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload2"
          accept="image/*,.pdf"
          onChange={handleChangeImage2}
          ref={imageInput2}
      />
      </Form.Group>
      {errors?.image2?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      </Row>
      <hr className="d-none d-md-block"/>
      {/* image 3 4 */}
      <Row className="d-flex align-items-center">
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 3</p>
      <Form.Group>
      {postData.image3Preview ? (
          postData.image3Type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image3Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload3"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image3Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload3"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload3"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload3"
          accept="image/*,.pdf"
          onChange={handleChangeImage3}
          ref={imageInput3}
      />
      </Form.Group>
      {errors?.image3?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      <Col xs={12} md={6} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 4</p>
      <Form.Group>
      {postData.image4Preview ? (
          postData.image4Type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image4Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload4"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image4Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload4"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload4"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload4"
          accept="image/*,.pdf"
          onChange={handleChangeImage4}
          ref={imageInput4}
      />
      </Form.Group>
      {errors?.image4?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>
      </Row>
      <hr className="d-none d-md-block"/>
      {/* image 5 */}
      <Row>
      <Col xs={12} md={{span: 6, offset: 3}} className={`text-center pr-md-2`}>
      <p className={`${styles.BoldScene} text-center mb-2 mt-md-0 mt-2`} >
      Image 5</p>
      <Form.Group>
      {postData.image5Preview ? (
          postData.image5Type === "application/pdf" ? (
          <>
              <iframe
              src={postData.image5Preview}
              width="40%"
              height="100px"
              style={{ borderRadius: 8, border: "none" }}
              title="PDF Preview"
              />
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload5"
              >
              Change the file
              </Form.Label>
          </>
          ) : (
          <>
              <figure>
              <Image
                  className={appStyles.iframe}
                  width="70%"
                  height="120px"
                  src={postData.image5Preview}
                  rounded
              />
              </figure>
              <Form.Label
              className={`${btnStyles.Button} ${btnStyles.Blue}`}
              htmlFor="image-upload5"
              >
              Change the image
              </Form.Label>
          </>
          )
      ) : (
          <Form.Label
          htmlFor="image-upload5"
          >
          <Asset
          src={Upload}
          height={"40px"}
          width={"40px"}
          message="Upload Image or PDF"
          />
          </Form.Label>
      )}

      <Form.Control
          type="file"
          id="image-upload5"
          accept="image/*,.pdf"
          onChange={handleChangeImage5}
          ref={imageInput5}
      />
      </Form.Group>
      {errors?.image5?.map((message, idx) => (
      <Alert variant="warning" key={idx}>
          {message}
      </Alert>
      ))}
      <hr className="d-block d-md-none"/>
      </Col>   
      </Row>
      <hr className="d-none d-md-block"/>
      </div>
        <Row>
          <Col>
            <Container className={`${styles.Container} mt-3`}>
              {buttons}{" "}
            </Container>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default MoodboardEdit
